
import { Placement } from '@post-office/placements-frontend/home-app-changeboarding';
export default Placement;
